import { render, staticRenderFns } from "./AgentCustomersList.vue?vue&type=template&id=78dc5abb&scoped=true&"
import script from "./AgentCustomersList.vue?vue&type=script&lang=js&"
export * from "./AgentCustomersList.vue?vue&type=script&lang=js&"
import style0 from "./AgentCustomersList.vue?vue&type=style&index=0&id=78dc5abb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dc5abb",
  null
  
)

export default component.exports